import { registerInsertBlockPatternBlock } from "src/insert-block-pattern-block/register-block-type";

registerInsertBlockPatternBlock();
